import {stripeCountries} from '@/constants/countries';
import type {AfriexCountry, SupportedAssets} from '@/types';
import {AfriexCurrencyCode} from '@/types';

export const mapCountryCodeToFlags = (countryList: AfriexCountry[]) => {
  return countryList.reduce(
    (acc: Record<string, string>, country: AfriexCountry) => {
      acc[country.iso2] = country.flag as string;
      return acc;
    },
    {},
  );
};

export const mapCountryListToOptions = (countryList: AfriexCountry[]) => {
  return countryList.reduce(
    (acc: Record<string, string>, country: AfriexCountry) => {
      acc[country.iso2] = `${country.name} ${country.flag}`;
      return acc;
    },
    {},
  );
};

export const mapCountryListToNameFlagOptions = (
  countryList: AfriexCountry[],
) => {
  const flagMap = mapCountryCodeToFlags(countryList);
  return countryList.map((p) => ({
    key: `${p.name}${flagMap[p.iso2]}`,
    value: p.iso2,
  }));
};

export const mapCountryListToCurrencyOptions = (
  countryList: AfriexCountry[],
) => {
  const unique = new Set<string>();
  return countryList
    .filter((item): item is AfriexCountry & {currency: AfriexCurrencyCode} =>
      Boolean(
        item.currency &&
        !unique.has(item.currency) &&
        unique.add(item.currency),
      ),
    )
    .map((item) => ({
      key: item.currency,
      value: item.currency,
    }));
};

export const mapCountryListToCurrencies = (
  countryList: AfriexCountry[],
): Record<string, string> => {
  return countryList.reduce(
    (acc: Record<string, string>, country: AfriexCountry) => {
      if (country.currency) {
        acc[country.currency] = `${country.name} ${country.flag}`;
      }
      return acc;
    },
    {},
  );
};

export function isStripeSupportedCountry(country: string): boolean {
  return stripeCountries.includes(country?.toUpperCase());
}

export const getUserCurrencyFromCountry = (
  countryList: AfriexCountry[],
  currentCountry: string,
) => {
  const currency = countryList.find(
    (val) => val.iso2 === currentCountry,
  )?.currency;
  return (currency as SupportedAssets) || AfriexCurrencyCode.USD;
};
